import { AppLayout } from '@cmg/design-system';
import type { VFC } from 'react';

import RootRouter from '../../../../../features/core/RootRouter';
import IdentityAppBar from '../app-bar/IdentityAppBar';

export const IdentityAppLayout: VFC = () => {
  return <AppLayout header={<IdentityAppBar />} page={<RootRouter />} />;
};
